import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditCourseCommunity from "../components/EditCourseCommunityLayer";
 
 
const EditCourseCommunityPage = () => {
  return (
    <>
     
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Course Community  </h5><Breadcrumb title="Edit Course Community" /></div>
 
        {/* CalendarMainLayer */}
        <EditCourseCommunity />

    </>
  );
};
 
export default EditCourseCommunityPage;
 
 